export default "__VITE_ASSET__D4R$dB67__"